'use strict';

var d3tip = require('d3-tip');
var Tooltip = function Tooltip() {
  var previousClasses = [];
  var toolTip;

  /**
   * @param tooltipHandler - a function that returns HTML content of the tooltip
   * @returns {Function}
   * @constructor
   */
  return function (tooltipHandler, tooltipClass) {
    if (previousClasses.indexOf(tooltipClass) === -1) {
      previousClasses.push(tooltipClass);
      toolTip = d3tip().attr('class', 'd3-tip d3-chart-tooltip' + (tooltipClass ? ' ' + tooltipClass : '')).html(tooltipHandler);
    }
    return toolTip;
  };
};
Tooltip.$inject = [];
module.exports = Tooltip;